import { PanelTitle } from './ui/MetricPanel';
import { Link } from 'react-router-dom';
import { usePollingResource } from '../hooks/usePollingResource';
import { fmtKst } from '../lib/format';
import ResourceNotice from './ResourceNotice';
import { StatusChip } from './ui/Primitives';
interface CalendarEvent {
    event_id: string;
    event_ts: string;
    country: string;
    title: string;
    importance: string;
}
interface Alert {
    alert_id?: string;
    ts?: string;
    timestamp?: string;
    title?: string;
    message?: string;
    detail?: string;
    severity?: string;
}
interface Canary {
    available?: boolean;
    verdict?: string;
    generated_at?: string;
    error?: string;
    raw?: {
        recent?: number;
        auth_failures?: number;
    };
    features?: {
        recent?: number;
        instruments?: number;
    };
    news?: {
        outbox_pending?: number;
        outbox_failed?: number;
        jobs_pending?: number;
        jobs_failed?: number;
    };
    checks?: {
        name: string;
        passed: boolean;
        detail: string;
    }[];
}
export default function IntelligenceMonitor({ revision = 0 }: {
    revision?: number;
}) {
    const canary = usePollingResource<Canary>(`/saveticker/canary?hours=24&_refresh=${revision}`, 60000);
    const calendar = usePollingResource<{
        events: CalendarEvent[];
    }>(`/calendar/upcoming?hours_ahead=72&_refresh=${revision}`, 60000);
    const alerts = usePollingResource<{
        alerts: Alert[];
    }>(`/alerts/recent?limit=5&_refresh=${revision}`, 15000);
    const c = canary.data;
    const verdict = !c || canary.error || c.available === false ? '미확인' : c.verdict === 'pass' ? '검사 통과' : c.verdict === 'fail' ? '확인 필요' : '미확인';
    return <div className="cockpit-page" id="intelligence-monitor">
    <section className="card"><div className="card-title-row"><PanelTitle>SaveTicker · 수집·스코어 작업</PanelTitle><StatusChip tone={verdict === '검사 통과' ? 'ok' : 'warn'}>{verdict}</StatusChip><Link className="research-link" to="/management/data/saveticker">파이프라인·자격 증명 →</Link></div>
      <ResourceNotice {...canary}/>
      <dl className="monitor-facts">
        <div><dt>24시간 원본</dt><dd>{c?.raw?.recent ?? '—'}건</dd></div>
        <div><dt>피처 · 종목</dt><dd>{c?.features?.recent ?? '—'} · {c?.features?.instruments ?? '—'}</dd></div>
        <div><dt>인증 실패</dt><dd>{c?.raw?.auth_failures ?? '—'}</dd></div>
        <div><dt>Outbox 대기 · 실패</dt><dd>{c?.news?.outbox_pending ?? '—'} · {c?.news?.outbox_failed ?? '—'}</dd></div>
        <div><dt>스코어 job 대기 · 실패</dt><dd>{c?.news?.jobs_pending ?? '—'} · {c?.news?.jobs_failed ?? '—'}</dd></div>
        <div><dt>검사 시각 · KST</dt><dd>{fmtKst(c?.generated_at)}</dd></div>
      </dl>
      <div className="monitor-checks">{c?.checks?.map(check => <StatusChip key={check.name} tone={check.passed ? 'ok' : 'warn'} title={check.detail}>{check.name} · {check.passed ? '확인' : '확인 필요'}</StatusChip>)}</div>
      {c?.error && <p className="research-alert">{c.error}</p>}
    </section>
    <div>
      <section className="card" aria-label="알림과 경제 일정"><div className="card-title-row"><PanelTitle>최근 알림 · 다음 경제 일정</PanelTitle><Link className="research-link" to="/management/alerts">알림 →</Link><Link className="research-link" to="/management/data/calendar">일정 →</Link></div><ResourceNotice {...alerts}/>
        <ul className="monitor-feed">{alerts.data?.alerts.map((alert, i) => <li key={alert.alert_id ?? i}><StatusChip tone={['critical', 'danger'].includes(alert.severity ?? '') ? 'danger' : 'warn'}>{alert.severity ?? '알림'}</StatusChip><p>{alert.title ?? alert.message ?? alert.detail ?? '상세 알림 조회 필요'}</p><span className="muted-note">{fmtKst(alert.ts ?? alert.timestamp)} KST</span></li>)}</ul>
        {alerts.data?.alerts.length === 0 && <p>최근 조회에 알림 없음</p>}
        <ResourceNotice {...calendar}/>
        <ul className="monitor-feed">{calendar.data?.events.map(event => <li key={event.event_id}><strong>{event.title}</strong><p className="muted-note">{fmtKst(event.event_ts)} KST · {event.country} · {event.importance}</p></li>)}</ul>
        {calendar.data?.events.length === 0 && <p>조회된 고위험 일정 없음 · 72시간 범위</p>}
        <p className="muted-note">뉴스·경제 일정은 C1의 진입 차단 조건으로 사용되지 않습니다.</p>
      </section>
    </div>
  </div>;
}
